(function () {
  'use strict';

  angular
    .module('factories.alert', ['factories.nativeBridge', 'factories.mobileHelper'])
    .factory('Alert', Alert);

  Alert.$inject = ['$window', 'NativeBridge', 'MobileHelper'];

  function Alert($window, NativeBridge, MobileHelper) {
    function show(title, message, okButtonUrl, okButtonTitle, cancelButtonTitle) {
      if (!cancelButtonTitle && !okButtonTitle)
        cancelButtonTitle = 'OK';

      cancelButtonTitle = cancelButtonTitle || 'Cancel';
      okButtonTitle = okButtonTitle || '';

      if (MobileHelper.isNativeIpadApp)
        return NativeBridge.fireHandler('alert', title + '[' + message + '[' + cancelButtonTitle + '[' + okButtonTitle + '[' + okButtonUrl);

      $window.alert(title + ": " + message);
    }

    return {
      show: show
    };
  }

})();
